import { AxiosResponse } from "axios";
import { format } from "date-fns";

import { useQuery } from "@tanstack/react-query";
import { FinanceCashFlowResponse } from "@/types";
import { httpRequest } from "@/lib";

type FinanceCashFlowReportProps = {
  page?: string | null;
  month?: string | null;
  per_page?: number | null;
};

export async function fetchFinanceCashFlowReport({
  page,
  month,
  per_page,
}: FinanceCashFlowReportProps): Promise<
  AxiosResponse<FinanceCashFlowResponse>
> {
  const formattedDate = format(new Date(), "yyyy-MM");
  const pageParams = `page=${page || 1}&month=${
    month || formattedDate
  }&per_page=${per_page || 10}`;
  return await httpRequest.get<FinanceCashFlowResponse>(
    `balance-report/finance-entries?${pageParams}`
  );
}

export function useFetchFinanceCashFlowReportQuery({
  page,
  month,
}: FinanceCashFlowReportProps) {
  const schedulingsResponseQuery = useQuery({
    queryKey: ["balance-report/finance-entries", page || "1", month],
    queryFn: () => fetchFinanceCashFlowReport({ page, month }),
    keepPreviousData: true,
    enabled: false,
  });

  return {
    ...schedulingsResponseQuery,
    data: schedulingsResponseQuery?.data?.data,
  };
}
